import { Typography } from '@/ui-kit';
import styles from './profile-verification-section.module.scss';
import { ArrowBackUpIcon, ErrorNotificationIcon, VerifiedAccountIcon } from '@/assets/icons';
import { useState } from 'react';
import { profilesApi } from '@/api';
import { useToast } from '@/store/useToast';
import { useAuth } from '@/store/useAuth';
import { SelfInitiatedVerificationBottomsheet } from '../self-initiated-verification-bottomsheet';
import { useTranslation } from 'react-i18next';

export const ProfileVerificationSection = () => {
    const showToast = useToast((state) => state.show);

    const [isVerificationModalOpen, setIsVerificationModalOpen] =
        useState(false);

    const userData = useAuth((state) => state.getUser());    
    const setUserData = useAuth((state) => state.setProfile);

    const { t } = useTranslation();

    const onVerificationBottomsheetOkClicked = async () => {
        try {
            await profilesApi.selfInitiateVerification()
            setUserData({ ...userData, verification_status: 'self_initiated' })
            return true
        } catch (e) {
            showToast({
                icon: <ErrorNotificationIcon />,
                msg: t('error_try_again')
            });
        }
        return false
    }

    return (
        <>
            <div className={styles.profileVerificationCard} onClick={() => setIsVerificationModalOpen(true)}>
                <div className={styles.profileVerificationCardMain}>
                    <Typography
                        variant="span"
                        fontWeight="bold"
                        className={styles.profileVerificationCardMainTitle}>
                        {t('profile.start_verification_secondary')}
                    </Typography>
                    <Typography
                        variant="span"
                        fontWeight="normal"
                        typeColor="gray-label"
                        className={styles.profileVerificationCardMainSubtitle}>
                        {t('profile.verification_increases_your_chances_secondary')}
                    </Typography>
                </div>
                <VerifiedAccountIcon className={styles.profileVerificationCardIcon} />
                <ArrowBackUpIcon className={styles.arrowIcon} />
            </div>        
            <SelfInitiatedVerificationBottomsheet
                isVerificationModalOpen={isVerificationModalOpen}
                setIsVerificationModalOpen={setIsVerificationModalOpen}
                onOkClicked={onVerificationBottomsheetOkClicked} />
        </>
    )
}
